export default __webpack_public_path__ + "static/media/folder-heart-active.4ab36673.svg";